/**
 * Read an uploaded credential file as text. Both push credential formats — an
 * APNS `.p8` key and an FCM service-account `.json` — are text the form sends
 * verbatim, so there is no binary path.
 *
 * Rejects when the file cannot be read, so a caller can surface the failure
 * instead of waiting on a promise that never settles.
 */
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => {
      reject(reader.error ?? new Error(`Could not read ${file.name}`));
    };
    reader.onload = () => {
      resolve(typeof reader.result === 'string' ? reader.result : '');
    };

    reader.readAsText(file);
  });
}
